const initialState = {
  planList: [],
  customerTypes: [],
};

export const plan_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PLANS":
      return {
        ...state,
        planList: action.payload,
      };
    case "GET_CUSTOMER_TYPES":
      return {
        ...state,
        customerTypes: action.payload,
      };
    case "DELETE_PLAN":
      return {
        ...state,
        planList: state.planList.filter((li) => li.id !== action.payload),
      };
    case "DELETE_CUSTOMER_TYPE":
      return {
        ...state,
        customerTypes: state.customerTypes.filter((li) => li.id !== action.payload),
      };
    default:
      return state;
  }
};
